import { IUserRepository } from "@/core/repositories/user";
import { UserContext } from "@/infrastructure/context";

/**
 * This is a use case that gets the user.
 * @example
 * const user = await new GetUserUseCase(new UserRepository()).execute();
 */
export class GetUserUseCase {
  constructor(private readonly userRepository: IUserRepository) {}
  async execute() {
    const user = await this.userRepository.getUser();
    UserContext.getInstance().setUser(user);
    return user;
  }
}
